import { render, staticRenderFns } from "./referrer-list.vue?vue&type=template&id=c3b823b4&scoped=true&"
import script from "./referrer-list.vue?vue&type=script&lang=js&"
export * from "./referrer-list.vue?vue&type=script&lang=js&"
import style0 from "./referrer-list.vue?vue&type=style&index=0&id=c3b823b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b823b4",
  null
  
)

export default component.exports